import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalBodyProps {
    children: ReactNode;
    className?: string;
    tabIndex?: number;
}

export const ResponsiveModalBody = (props: IResponsiveModalBodyProps) => {
    const {children, className, tabIndex = 0} = props;
    const viewportRef = useResponsiveModalPartRef("bodyViewport");
    const contentRef = useResponsiveModalPartRef("bodyContent");

    return (
        <div ref={viewportRef} className={styles.body} tabIndex={tabIndex}>
            <div ref={contentRef} className={classNames(styles.bodyContent, className)}>
                {children}
            </div>
        </div>
    );
};
import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalBodyProps {
    children: ReactNode;
    className?: string;
    tabIndex?: number;
}

export const ResponsiveModalBody = (props: IResponsiveModalBodyProps) => {
    const {children, className, tabIndex = 0} = props;
    const viewportRef = useResponsiveModalPartRef("bodyViewport");
    const contentRef = useResponsiveModalPartRef("bodyContent");

    return (
        <div ref={viewportRef} className={styles.body} tabIndex={tabIndex}>
            <div ref={contentRef} className={classNames(styles.bodyContent, className)}>
                {children}
            </div>
        </div>
    );
};
